import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { api_url } from '../../utils/utils'

export const get_seller_dashboard_index_data = createAsyncThunk(
    'dashboardIndex/get_seller_dashboard_index_data',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        const token = getState().auth.token
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        try {
            const { data } = await axios.get(`${api_url}/api/seller/get-dashboard-index-data`, config)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_admin_dashboard_index_data = createAsyncThunk(
    'dashboardIndex/get_admin_dashboard_index_data',
    async (_, { rejectWithValue, fulfillWithValue, getState }) => {
        const token = getState().auth.token
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        try {
            const { data } = await axios.get(`${api_url}/api/admin/get-dashboard-index-data`, config)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)



export const dashboardIndexReducer = createSlice({
    name: 'dashboardIndex',
    initialState: {
        totalSale: 0,
        totalOrder: 0,
        totalProduct: 0,
        totalPendingOrder: 0,
        totalSeller: 0,
        totalSellerEarnings: 0,
        adminCommission: 0,
        totalPaidToSellers: 0,
        sellerRemainingBalance: 0,
        adminShare: 0,
        recentOrders: [],
        recentMessage: [],
        chartData: {
            orders: [],
            revenue: [],
            sales: [],
            sellers: []
        }
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: {
        [get_seller_dashboard_index_data.fulfilled]: (state, { payload }) => {
            state.totalSale = payload.totalSale
            state.totalOrder = payload.totalOrder
            state.totalProduct = payload.totalProduct
            state.totalPendingOrder = payload.totalPendingOrder
            state.recentOrders = payload.recentOrders
            state.recentMessage = payload.messages
            state.chartData = payload.chartData || {
                orders: [],
                revenue: [],
                sales: []
            }
        },
        [get_admin_dashboard_index_data.fulfilled]: (state, { payload }) => {
            state.totalSale = payload.totalSale
            state.totalOrder = payload.totalOrder
            state.totalProduct = payload.totalProduct
            state.totalSeller = payload.totalSeller
            state.totalSellerEarnings = payload.totalSellerEarnings || 0
            state.adminCommission = payload.adminCommission || 0
            state.totalPaidToSellers = payload.totalPaidToSellers || 0
            state.sellerRemainingBalance = payload.sellerRemainingBalance || 0
            state.adminShare = payload.adminShare || 0
            state.recentOrders = payload.recentOrders
            state.recentMessage = payload.messages
            state.chartData = payload.chartData || {
                orders: [],
                revenue: [],
                sellers: []
            }
        }
    }

})
export const { messageClear } = dashboardIndexReducer.actions
export default dashboardIndexReducer.reducer